import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { UnifiedSearchAPI } from '../../services';
import Table from './Table';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { LanguageLoader } from '../../assets/languages';

const Search = () => {
	const settings = useSelector((state) => state.settings);
	const preferences = useSelector((state) => state.preferences);
	const language = LanguageLoader(preferences.language);
	const { searchString } = useParams();
	const [search, SetSearch] = useState([]);
	const [activeTab, setActiveTab] = useState(0);
	const [searchTerm,SetSearchTerm] = useState(searchString);
	const [fromHere,SetFromHere] = useState(false);
	const [firstLoad, SetFirstLoad] = useState(true);
	const navigate = useNavigate();
	
	const handleSearch = () => 
	{
		SetFromHere(true);
		navigate(`/search/${searchTerm}`);
		if(!firstLoad)
		{
			DoSearch();
		}
	};

	useEffect(() => {
		if(fromHere && firstLoad)
		{
			SetFirstLoad(false);
			DoSearch();
		}
		// eslint-disable-next-line
	},[fromHere]);

	useEffect(() => {
		DoSearch();
		// eslint-disable-next-line
	},[]);

	const DoSearch = async () => {
		const modules = settings.definitions.modules;
		const modulesArray = Object.keys(modules);
		let searchWords = '';
		if(fromHere)
		{
			searchWords = searchTerm;
		}
		else
		{
			searchWords = searchString;
		}
		if(searchWords !== null)
		{
			const data = {
				search : searchWords,
				modules : modulesArray
			}
			const APIResponse = await UnifiedSearchAPI(data);
			if(APIResponse)
			{
				const formattedData = Object.entries(APIResponse).map(([title, content]) => ({
					title,
					content
				  }));
				SetSearch(formattedData);
			}
		}
	}
	
	return (
		<div className='wrapper'>
			<div className="flex w-full">
				<div className="Field_Container">
					<label>{language.FILTER.SEARCH}</label>
					<input type="text" onChange={(e) => SetSearchTerm(e.target.value)} value={searchTerm} />
				</div>
				<div className="Field_Container">
					<button className='btn btn-success mt-6 h-11 w-10 px-2' onClick={handleSearch}><i className='fa fa-search'></i></button>
				</div>
			</div>
			<div className="flex w-full">
			{search.length ?
				<>
				<div className="ml-4 w-1/6">
					<div className="flex flex-col">
						{Array.isArray(search) && search.map((tab, index) => (
						<div key={index} className={`px-4 py-4 cursor-pointer text-sm border-b border-primaryBorder  ${index === activeTab ? 'bg-primary text-white rounded-lg' : ''}`} onClick={() => setActiveTab(index)}>
							{settings.definitions.modules[tab.title].label[preferences.language]}
						</div>
						))}
					</div>
				</div>
				<div className="flex flex-col w-full">
					{Array.isArray(search) && search.map((tab, index) => (
					<div key={index} className={`${index === activeTab ? 'block' : 'hidden'}`}>
						<Table itemsPerPage={10} header={{name: language.FIELDS.NAME, date_modified: language.FIELDS.DATE_MODIFIED}}>
							{Array.isArray(tab.content) && tab.content.map((item, itemIndex) =>
							{
								return <tr key={itemIndex} >
									<td><Link to={`/detail/${item.module_dir}/${item.id}`}>{item.name}</Link></td>
									<td>{item.date_modified}</td>
								</tr>
							})}
						</Table>
					</div>
					))}
				</div>
				</>
				: language.ERROR.NOTHING_TO_SHOW }
			</div>
		</div>
	);
};

export default Search;